import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const EFFECTIVE_DATE = "February 14, 2026";

const RefundPolicyPage = () => {
  return (
    <div className="min-h-screen" style={{ background: "#1a1a1e" }} data-testid="refund-policy-page">
      <div className="border-b border-gray-800" style={{ background: "#0f0f11" }}>
        <div className="container-custom py-4">
          <Link to="/"><Button variant="ghost" className="text-purple-400" data-testid="refund-back">← Back</Button></Link>
        </div>
      </div>
      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8" style={{ background: "rgba(42, 26, 58, 0.5)", borderColor: "rgba(138, 43, 226, 0.3)" }}>
            <h1 className="text-4xl font-bold text-white mb-2">Refund Policy</h1>
            <p className="text-sm text-purple-300 mb-8">Effective Date: {EFFECTIVE_DATE}</p>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <h2 className="text-2xl font-bold text-white">Virtual Coins</h2>
              <p>
                Coin purchases are <span className="text-white">non-refundable</span> once delivered to your
                wallet, except where required by law. Unused coins remain in your wallet and can be spent
                on gifts, features, and other platform services.
              </p>

              <h2 className="text-2xl font-bold text-white">Failed or Duplicate Charges</h2>
              <p>If a Stripe charge fails to deliver coins, or you were billed twice for the same pack, contact us within 30 days and we will investigate. Verified errors will be refunded to the original payment method.</p>

              <h2 className="text-2xl font-bold text-white">Magazine & Digital Goods</h2>
              <p>Magazine issues and other digital goods are delivered immediately on purchase and are non-refundable, except where required by law.</p>

              <h2 className="text-2xl font-bold text-white">Subscriptions</h2>
              <p>If RGM Studio offers subscriptions, you may cancel any time. Cancellations stop future renewals; the current billing period is not pro-rated.</p>

              <h2 className="text-2xl font-bold text-white">Chargebacks</h2>
              <p>If you initiate a chargeback, your account may be suspended pending review and any related earnings reversed.</p>

              <h2 className="text-2xl font-bold text-white">Contact</h2>
              <p>📧 <a className="text-purple-300 underline" href="mailto:realglobalmusicent@yahoo.com">realglobalmusicent@yahoo.com</a></p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
